<template lang="pug">
page(
    main-title="Службы доставки",
    main-description="Настройки служб и способов доставки"
)
    .panel.margin-bottom-0
        .panel-body
            tariff-loading-settings(ref="loading-settings")
            
    .grid(v-if="deliveryServicesLoaded")
      .panel.grid-item(v-for='(delivery, index) in deliveries', :class="{'grid-sizer': !index}")
        .panel-heading
          .panel-title
            | {{ delivery.name }} 
            a(
                v-if="!(delivery.manual && !delivery.delivery_methods.length)",
                @click.prevent="editDeliveryService(delivery)"
            ) <i class="fa fa-cog"></i>
        .panel-body
          .margin-bottom-10(v-for='item in delivery.delivery_methods')
            .checkbox
              input.js-switch(
                type='checkbox', 
                :checked='item.active', 
                :data-switchery='item.active', 
                @change="onSwitch($event, item.id, delivery)"
              )
            p(v-if="delivery.manual && !item.read_only")  
                a(@click.prevent="edit(item)") {{ item.name }}
            p(v-else) {{ item.name }}

          button.btn.btn-default.margin-bottom-10(
              v-if="delivery.manual",
              @click="edit({})"
          ) Добавить
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import TariffLoadingSettings from '@/components/TariffLoadingSettings';

export default {
    created() {
        this.getDataHook();
    },
    mounted() {
        if (this.deliveryServicesLoaded) initializeLocalElements();
    },
    name: 'DeliveryServices',
    components: {
        TariffLoadingSettings
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('loadDeliveryServices')
                .then(initializeLocalElements);

            this.$refs['loading-settings'] && this.$refs['loading-settings'].getDataHook();
        },
        onSwitch(event, delivery_method_setting_id, delivery) {
            this.$store.dispatch('switchDeliveryMethod', {
                delivery_method_setting_id,
                active: event.target.checked
            }).then(_ => {
                const activeDeliveryMethods = delivery.delivery_methods.filter(i => i.active);
                // Если после включения/выключения не осталось ни одного активного способа доставки
                // или остался только один и это тот, который мы изменяли –
                // значит пора обновить данные о статусе загрузки
                if (!activeDeliveryMethods.length || (activeDeliveryMethods.length == 1 &&
                        activeDeliveryMethods[0].id == delivery_method_setting_id)) {
                    this.$refs['loading-settings'].getDataHook();
                }
            });
        },
        edit(item) {
            this.$store.commit('selectEditedManualDM', {
                data: {
                    ...item,
                    id: item.delivery_method_id
                }
            });
            this.$router.push({name: 'EditManualDeliveryMethod'});
        },
        editDeliveryService(deliveryService) {
            this.$store.commit('selectEditedDeliveryService', {
                data: deliveryService
            });
            this.$router.push({name: 'EditDeliveryService'});
        }
    },
    computed: {
        ...mapGetters([
            'deliveries'
        ]),
        ...mapState({
            deliveryServicesLoaded: state => state.deliveryServices.loaded
        })
    }
};
</script>

<style lang="sass" scoped>
    .panel-body div 
        clear: all

        .checkbox
            float: left 
            margin: -2px 15px 0 0

    .grid-sizer, .grid-item
        width: 33%

    @media (min-width:"1480px")
        .grid-sizer, .grid-item
            width: 24%

    @media (max-width:"768px")
        .grid-sizer, .grid-item
            width: 49%
    
    @media (max-width:"480px")
        .grid-sizer, .grid-item
            width: 99%

    .panel-title a
        color: #007AFF!important
</style>


// WEBPACK FOOTER //
// src/components/deliveryServices/DeliveryServices.vue